import { BehaviorSubject, Subscription } from 'rxjs';
import { Pagination } from '../api/api';
import { Directive, OnDestroy, signal } from '@angular/core';

@Directive()
export abstract class RequestClass implements OnDestroy {
  /* global */
  loading = signal(true);
  protected subs: Subscription[] = [];
  protected pagination: BehaviorSubject<Pagination> | undefined = undefined;
  private timer: ReturnType<typeof setTimeout> | null = null;

  // request methods
  requestDebounced(options?: BehaviorSubject<Pagination>) {
    this.loading.set(true);
    if (options) {
      this.pagination = options;
    }

    if (this.timer) {
      clearTimeout(this.timer);
    }

    this.subs.forEach(sub => sub.unsubscribe());
    this.subs = [];

    this.timer = setTimeout(() => {
      this.refreshFromServer();
    }, 500);
  }

  protected abstract refreshFromServer(): void;

  ngOnDestroy() {
    if (this.subs && this.subs.length > 0) {
      this.subs.forEach(sub => sub.unsubscribe());
      this.subs = [];
    }
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    if (this.pagination) {
      this.pagination.next(null);
      this.pagination.complete();
      this.pagination.unsubscribe();
      this.pagination = undefined;
    }
  }
}
